import { render, staticRenderFns } from "./BumperBoxUpgradeModal.vue?vue&type=template&id=107873e4&scoped=true&"
import script from "./BumperBoxUpgradeModal.vue?vue&type=script&lang=js&"
export * from "./BumperBoxUpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./BumperBoxUpgradeModal.vue?vue&type=style&index=0&id=107873e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107873e4",
  null
  
)

export default component.exports